import React, { Component } from "react";
import "../css/Styles.css";

class AboutContent extends Component {
  render() {
    return (
      <div className="About-Content">
        <p>
          It’s Your Move was created after seeing the impact of physical
          isolation and social disruption on friends and family and our world at
          large. At the same time, a half a world away, Ultra cyclist Dr. Amit
          Samarth was planning an inspiring Ride Around India. Yes, all of it.
          6,000 kilometers on the famed Golden Quadrilateral connecting Mumbai,
          Chennai, Kolkata, and Delhi. A partnership was born.
        </p>
        <p>
          Today, “It’s Your Move” athletes include 3 men, 3 women and adventures
          that span 4 continents and 5 countries. They include ultradistance
          road cycling, gravel cycling, dogsled mushing, and snowshoe running.
          It’s a global project for health and wellbeing and for a world alive
          with purpose, healthy both physically and mentally, and connected to
          each other.
        </p>
        <p>
          We are building a technical platform that can share these adventures
          like never before. Not only will we map their routes and aggregate
          social media, we will be streaming live biometric and performance data
          to the cloud and right to you, our followers. We invite you to use
          their perspiration, heartbeats, and commitment to inspire your pledge
          of exercise, mindfulness, or social connection.
        </p>
        <p>
          Please share your pledge with your social followers with the hashtag
          #itsyourmove2021 and tag three friends.
        </p>
        <p>
          Our technology team is supported by technology, fitness, and health
          leaders Mapbox, The Weather Company (an IBM Business), Narrative
          Science, Garmin, Moxy, CORE, and HealthIO (Milliman). Project
          leadership and programming is provided by UW-Madison Computer, Data,
          and Information Science Undergraduate Project Lab.
        </p>
        <p>
          We are confident that this is the future of sports. The future of
          fitness. The future of health and wellbeing; Live contextual,
          biometric and performance data.
        </p>
        <p>Thanks for being here. And thanks for sharing with others.</p>
      </div>
    );
  }
}

export default AboutContent;
